import React from 'react';
import HCaptcha from '@fuww/library/src/Captcha';
import withController from '@fuww/library/src/lib/withController';
import { useSiteContext } from './SiteContext';

const Captcha = React.forwardRef(
  (properties, reference) => {
    const { production } = useSiteContext();

    return (
      <HCaptcha
        {...properties}
        sitekey={production
          ? '3bbd4a2a-9535-4995-9e8d-41d7a57b2ee7'
          : '10000000-ffff-ffff-ffff-000000000001'}
        ref={reference}
      />
    );
  },
);

export const CaptchaWithController = withController(Captcha);

export default Captcha;
